<template>
    <div class="title" :style="{color: color}">
        <h4>{{ title }} <span v-if="required" class="required-asterisk">*</span></h4>
    </div>
</template>

<script>
    export default {
        name: 'QuestionTitle',
        props: ['title', 'required', 'color'],
        methods: {

        }
    }
</script>

<style scoped>
    .title h4 {
        font-size: 15px !important;
        font-weight: 700;
        margin-bottom: 0;
        margin-top: 0;
    }
</style>
